import React, { useEffect, useState, useRef, useCallback } from "react";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TableWrapper from "../../../core/BaseComponents/TableWrapper/TableWrapper";
// import GlobalProps from "../../../core/BaseComponents/TableWrapper/Global";
import { Link, useNavigate } from "react-router-dom";
import { MdModeEditOutline } from "react-icons/md";
import { Drawer, IconButton, Switch, Tooltip } from "@mui/material";
import { callAPI } from "../../../../axios";
import PropTypes from "prop-types";
import approveQc from "../../../../assets/images/approve-qc.png";
import rejectImage from "../../../../assets/images/Rejected.png";
import enabledImg from "../../../../assets/images/enabled.png";
import disabledImg from "../../../../assets/images/disabled.png";
import BasicModal from "../../../core/BaseComponents/Modal";
import Search from "../../../core/BaseComponents/Search";
import { debounce } from "lodash";
import CloseIcon from "@mui/icons-material/Close";
import CommonFilter from "./CommonFilter";
import dayjs from "dayjs";
import Custom_Paingation from "../../../core/BaseComponents/Custom_Paingation";

// const DEFAULT_PAGE_OPTION = GlobalProps.DEFAULT_PAGE_OPTION;

const UserList = ({ moduleType }) => {
  const navigate = useNavigate();
  const recordsPerPage = 10;
  const today = new Date().getTime();
  let userId = JSON.parse(localStorage.getItem("userDetails"))?.sid;
  // const [pageOptions, setPageOptions] = useState(DEFAULT_PAGE_OPTION);
  const [userList, setUserList] = useState({});
  const [approvalsReject, setApprovalsReject] = useState(false);
  const [enabledDisableUser, setEnabledDisableUser] = useState(false);
  const [right, setRight] = useState(false);
  const [filterData, setFilterData] = useState({
    approvalPending: moduleType === "isApprovalPending" ? true : false,
    freeText: null,
    roleSids: [],
    userStatus: [],
    hotelNames: [],
  });
  const [searchText, setSearchText] = useState("");
  // const [searchFlag, setSearchFlag] = useState(false);

  const [selectedPage, setSelectedPage] = useState(1);
  const [totalPageCount, setTotalPageCount] = useState(1);
  const [paginationError, setPaginationError] = useState("");
  const [inputPageValue, setInputPageValue] = useState(1);

  const toggleDrawer = (side, open) => () => {
    side(open);
  };

  const isUserApprovalRef = useRef({
    userApprovalModalData: null,
    userConformationModalData: null,
  });

  const isUserEnableModalRef = useRef({
    userConfirmationModalData: null,
    acknowledgementModalData: null,
  });

  const userRejectApprovalHandler = (row) => {
    setApprovalsReject(true);
    const sid = row.sid;
    const newModalRefData = {
      userApprovalModalData: {
        sid,
      },
      userConformationModalData: null,
    };
    isUserApprovalRef.current = newModalRefData;
  };

  const renderStatusActionIcon = (row) => {
    // const expired = new Date(row.accessTillDate) < today;
    const expired = row.accessTillDate
      ? new Date(row.accessTillDate) < today
      : false;
    const status = row.accountLocked
      ? "Account Locked"
      : expired
      ? "Expired"
      : row.enabled
      ? "Active"
      : "Inactive";
    return (
      <span
        className={`mb-0 ${
          !row.enabled
            ? "userdeactive"
            : row.accountLocked
            ? "userlocked"
            : expired
            ? "userexpired"
            : ""
        } ${row.enabled ? "useractive" : ""}`}
      >
        {status}
      </span>
    );
  };

  // const renderUserAccessIcon = (row) => {
  //   return <span>{row.roles[0]?.role}</span>;
  // };

  const renderActionIcon = (row) => {
    return (
      <>
        <Tooltip title="Edit" arrow>
          <MdModeEditOutline
            className={row.sid === userId?"edit-icon-disable":"edit-icon-enable"}
            onClick={() =>
              !(row.sid === userId) && navigate("/hms/editUser", {
                state: { sid: row.sid, isEditUser: true },
              })
            }
          />
        </Tooltip>

        <Tooltip title={row.sid === userId?"":row.enabled ? "Active" : "Inactive"} arrow>
          <Switch
            name="enabled"
            inputProps={{ "aria-label": "controlled" }}
            onChange={(event) => !(row.sid === userId) && handleToggleChange(event, row)}
            value={row.enabled}
            checked={row.enabled}
            className={`${
              row.enabled === false
                ? "switchuser-inactive"
                : "switchuser-active"
            } ${row.sid === userId?"edit-icon-disable":""}`}
          />
        </Tooltip>
      </>
    );
  };
  const renderPendingApprovels = (row) => {
    return (
      <>
        <Tooltip title="APPROVE" arrow>
          <img
            src={approveQc}
            alt="approve"
            className="w-40px"
            onClick={() =>
              navigate("/hms/editUser", {
                state: { sid: row.sid, isPendingApprovalStatus: true },
              })
            }
          />
        </Tooltip>
        <Tooltip title="REJECT" arrow>
          <img
            src={rejectImage}
            alt="Rejected"
            onClick={() => userRejectApprovalHandler(row)}
            className="w-40px"
          />
        </Tooltip>
      </>
    );
  };
  const columns =
    moduleType === "isApprovalPending"
      ? [
          {
            field: "createdDate",
            headerName: "Date & Time",
            flex: 1,
            row: true,
            renderCell: (row) => (
              <p className="mb-0">
                {dayjs(row.createdDate).format("DD MMM YYYY | HH:mm")}
              </p>
            ),
          },
          { field: "firstName", headerName: "First Name", flex: 1 },
          { field: "lastName", headerName: "Last Name", flex: 1 },
          { field: "userName", headerName: "User Name", flex: 1 },
          // {
          //   field: "hotelName",
          //   headerName: "Hotel Name",
          //   flex: 1,
          //   row: true,
          //   renderCell: (row) => (
          //     <span>
          //       {row?.roles[0]?.role === "Super Admin"
          //         ? "All"
          //         : row.hotelName
          //         ? row.hotelName
          //         : "N.A"}
          //     </span>
          //   ),
          // },
          {
            field: "actionCell",
            row: true,
            headerName: "Approval Status",
            flex: 0.5,
            renderCell: renderPendingApprovels,
            sortDirection: false,
            disableSortIcon: true,
          },
        ]
      : [
          {
            field: "createdDate",
            headerName: "Date & Time",
            flex: 1,
            row: true,
            renderCell: (row) => (
              <p className="mb-0">
                {dayjs(row.createdDate).format("DD MMM YYYY | HH:mm")}
              </p>
            ),
          },
          { field: "firstName", headerName: "First Name", flex: 1 },
          { field: "lastName", headerName: "Last Name", flex: 1 },
          { field: "userName", headerName: "Email", flex: 1 },
          {
            field: "hotelName",
            headerName: "Hotel Name",
            flex: 1,
            row: true,
            renderCell: (row) => (
              <span>
                {row?.hotelName?.split(',').length>1?<span>{row?.hotelName?.split(',')[0]}... 
                  <Tooltip title={row?.hotelName} arrow><span className="ms-2 cdsn-count">+{row?.hotelName?.split(',').length-1}</span></Tooltip></span>
                  :row?.hotelName?.split(',')[0]}
              </span>
            ),
          },
          {
            field: "userType",
            row: true,
            headerName: "User Type",
            flex: 0.5,
            // renderCell: renderUserAccessIcon,
            // sortDirection: false,
          },
          {
            field: "status",
            headerName: "Status",
            row: true,
            flex: 0.5,
            renderCell: renderStatusActionIcon,
            sortDirection: false,
          },
          {
            field: "actionCell",
            row: true,
            headerName: "Actions",
            flex: 0.5,
            renderCell: renderActionIcon,
            sortDirection: false,
            disableSortIcon: true,
          },
        ];

  const renderUserTypeValue = (user) => {
    if (user && user.roles[0] && user.roles[0].role) {
      return user.roles[0].role;
    }
    return "";
  };

  const userStatusFormatter = (row) => {
    // const expired = new Date(row.accessTillDate) < today;
    const expired = row.accessTillDate
      ? new Date(row.accessTillDate) < today
      : false;
    const status = row.accountLocked
      ? "Account Locked"
      : expired
      ? "Expired"
      : row.enabled
      ? "Active"
      : "Inactive";
    return status;
  };

  const userListApi = () => {
    const apiPath = `user/search?pageNo=${selectedPage}&recordsPerPage=${recordsPerPage}`;
    callAPI(apiPath, "POST", filterData)
      .then((response) => {
        const updatedUserList = response?.data?.users?.map((userData) => ({
          ...userData,
          status: userStatusFormatter(userData),
          userType: renderUserTypeValue(userData),
        }));

        setUserList({
          ...response,
          data: {
            ...response.data,
            users: updatedUserList,
          },
        });
        setTotalPageCount(response?.data?.totalPages);
        setPaginationError("");
      })
      .catch((err) => console.warn(err.message));
  };

  const initialRender = useRef(true);

  useEffect(() => {
    userListApi(filterData);
  }, [selectedPage, filterData]);

  // const setPage = (_, newPage) => {
  //     setPageOptions((prev) => ({
  //         ...prev,
  //         recordsPerPage: recordData,
  //         pageSize: recordData,
  //         pageNo: newPage + 1,
  //     }));
  // };

  // const handleSelectedPerPage = (data) => {
  //     setPageOptions((prev) => ({
  //         ...DEFAULT_PAGE_OPTION,
  //         recordsPerPage: data,
  //         pageSize: data,
  //         filter: prev.filter,
  //     }));
  // };

  const popupCloseHandler = () => {
    setApprovalsReject(false);
    setEnabledDisableUser(false);
  };
  const rejectHandler = () => {
    const { sid } = isUserApprovalRef.current?.userApprovalModalData;
    callAPI(`/user/signup-reject?sid=${sid}`, "PUT")
      .then((response) => {
        let successMessage = response.message;
        const newModalRefData = {
          userApprovalModalData: null,
          userConformationModalData: {
            successMessage,
          },
        };
        isUserApprovalRef.current = newModalRefData;
        userListApi(filterData);
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  const handleToggleChange = (e, row) => {
    const sid = row.sid;
    const userName = row.firstName + " " + row.lastName;
    const { value } = e.target;
    const isEnabled = value !== "true";
    setEnabledDisableUser(true);
    const newModalRefData = {
      userConfirmationModalData: {
        sid,
        userName,
        isEnabled,
      },
      acknowledgementModalData: null,
    };
    isUserEnableModalRef.current = newModalRefData;
  };

  const enabledTrue = () => {
    const { sid, isEnabled } =
      isUserEnableModalRef.current?.userConfirmationModalData;
    callAPI(`/user/enable?sid=${sid}&isEnabled=${isEnabled}`, "PUT")
      .then(() => {
        const newModalRefData = {
          userConfirmationModalData: null,
          acknowledgementModalData: {
            userIsEnabled: isEnabled,
          },
        };
        isUserEnableModalRef.current = newModalRefData;
        userListApi(filterData);
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  const handleSearch = (search) => {
    setFilterData((prev) => ({ ...prev, freeText: search }));
  };

  // Delay search by 600ms
  const delayedSearch = useCallback(
    debounce((searchText) => handleSearch(searchText), 600),
    []
  );

  const handleFilter = (filterData, flag) => {
    setFilterData((prev) => ({ ...prev, ...filterData }));
    if (flag) {
      toggleDrawer(setRight, false)();
    }
    // setSearchText("");
  };

  //Pagination Handle changer
  const onPageChange = (event, value) => {
    setInputPageValue(value);
    setPaginationError("");
    setSelectedPage(value);
  };

  return (
    <div className="row-header">
      <div className="breadcrumb">
        <ul>
          <li>
            <Link to="/hms/ConfigurationNewHotel">Dashboard </Link>{" "}
            <span className="arrow-color"> &gt; </span>
          </li>
          {moduleType === "isApprovalPending"?<li><Link to="/hms/userList">User Management List </Link> <span className="arrow-color" > &#62; </span></li>:<li>User Management List</li>}
          {moduleType === "isApprovalPending"?<li>Pending Approvals List</li>:""}
        </ul>
      </div>

      <div className="sub-header">
        <h1>User Management List {`(${userList?.data?.users?.length?userList?.data?.users?.length:0})`}</h1>
        <div className="sub-header-right">
          {moduleType !== "isApprovalPending" && (
            <>
              <Link to="/hms/createEditUser" className="sub-header_create-user">
                Create User
              </Link>
              <Link
                to="/hms/pending-approvals"
                className="sub-header_pending-approval"
              >
                Pending Approvals
              </Link>
              <Search
                placeholder={"Search User..."}
                handleSearch={delayedSearch}
                searchText={searchText}
                // flag={searchFlag}
              />
              <Tooltip title="Filters" arrow>
                <div className="filter" onClick={toggleDrawer(setRight, true)}>
                  <FontAwesomeIcon icon={faFilter} />
                </div>
              </Tooltip>
            </>
          )}
        </div>
      </div>
      <Drawer
        anchor="right"
        open={right}
        onClose={toggleDrawer(setRight, false)}
      >
        <div tabIndex={0} role="button">
          <IconButton
            onClick={toggleDrawer(setRight, false)}
            style={{ float: "right", color: "#fff" }}
          >
            <CloseIcon onClick={toggleDrawer(setRight, false)} />
          </IconButton>
          <CommonFilter handleFilter={handleFilter} filter={filterData} />
        </div>
      </Drawer>
      <TableWrapper
        data={userList?.data?.users}
        columns={columns}
        // rowCount={userList?.data?.totalCount}
        // selectedPerPage={handleSelectedPerPage}
        // onPageChange={setPage}
        module="userList"
        // {...pageOptions}
        noPagination={true}
      />
      <Custom_Paingation
        selectedPage={selectedPage}
        totalPageCount={totalPageCount}
        paginationError={paginationError}
        inputPageValue={inputPageValue}
        setSelectedPage={setSelectedPage}
        setPaginationError={setPaginationError}
        setInputPageValue={setInputPageValue}
        onPageChange={onPageChange}
      />
      <BasicModal
        popupOpen={approvalsReject}
        bodyMessage={
          <>
            <img src={rejectImage} alt="Reject" />
            <p>
              {isUserApprovalRef.current?.userApprovalModalData
                ? "Do you really want to Reject the Approval"
                : isUserApprovalRef.current?.userConformationModalData
                    ?.successMessage}
            </p>
          </>
        }
        footer={
          isUserApprovalRef.current?.userApprovalModalData
            ? {
                primaryButton: {
                  buttonName: "Cancel",
                  action: popupCloseHandler,
                },
                secondaryButton: {
                  buttonName: "Reject",
                  action: rejectHandler,
                },
              }
            : {
                primaryButton: {
                  buttonName: "Close",
                  action: popupCloseHandler,
                },
              }
        }
      />
      <BasicModal
        popupOpen={enabledDisableUser}
        footer={
          isUserEnableModalRef.current?.userConfirmationModalData
            ? {
                primaryButton: {
                  action: popupCloseHandler,
                  buttonName: "Cancel",
                },
                secondaryButton: {
                  action: enabledTrue,
                  buttonName: "Yes",
                },
              }
            : {
                secondaryButton: {
                  action: popupCloseHandler,
                  buttonName: "OK",
                },
              }
        }
        bodyMessage={
          <>
            {isUserEnableModalRef.current?.userConfirmationModalData && (
              <>
                <img
                  className="w-40px"
                  alt="enabledOrDisabled"
                  src={
                    isUserEnableModalRef.current?.userConfirmationModalData
                      ?.isEnabled
                      ? enabledImg
                      : disabledImg
                  }
                />
                <p>
                  Do you really want to
                  {isUserEnableModalRef.current?.userConfirmationModalData
                    ?.isEnabled
                    ? " Enable "
                    : " Disable "}
                  this user ?
                </p>
              </>
            )}
            {isUserEnableModalRef.current?.acknowledgementModalData && (
              <>
                <span className="d-block">
                  <img src={approveQc} alt="approveQc" />
                </span>
                <p className="mt-3">
                  Successfully
                  {isUserEnableModalRef.current?.acknowledgementModalData
                    ?.userIsEnabled
                    ? " Enabled "
                    : " Disabled "}
                  !
                </p>
              </>
            )}
          </>
        }
      />
    </div>
  );
};

UserList.propTypes = {
  moduleType: PropTypes.string,
};

export default UserList;
